export const ACQUISITION_CHANNELS = [
  { value: "standard_tender", label: "Standard tender" },
  { value: "off_market", label: "Off-market" },
  { value: "referral", label: "Referral" }
];

export const ACQUISITION_CHANNEL_LABELS = ACQUISITION_CHANNELS.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const CONTRACT_TYPES = [
  { value: "permanent_contract", label: "Permanent contract" },
  { value: "freelance", label: "Freelance" },
  { value: "subcontracting", label: "Subcontracting" },
  { value: "umbrella_company", label: "Umbrella company" }
];

export const CONTRACT_TYPE_LABELS = CONTRACT_TYPES.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});


